import { render, staticRenderFns } from "./VCostsInboxGlobal.vue?vue&type=template&id=39af0f2b&"
import script from "./VCostsInboxGlobal.vue?vue&type=script&lang=js&"
export * from "./VCostsInboxGlobal.vue?vue&type=script&lang=js&"
import style0 from "./VCostsInboxGlobal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports